module.exports = __webpack_public_path__ + "static/media/license_front.8568d6fc.svg";